import { AutoComplete, SelectPaper, StyledTextField } from "@includes";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTranslation } from "react-i18next";
import { getOptions } from "./helpers";
import { IEvolutionMetricSelector } from "./types";
import { useExperienceAnalytics } from "../../hooks/useExperienceAnalytics";
import { useSelector as useXstateSelector } from "@xstate/react";

const EvolutionMetricSelector: React.FC<IEvolutionMetricSelector> = ({
  evolutionKey,
  handleChange,
  isComparaison = false,
}) => {
  const { t }: i18translateType = useTranslation();
  const experienceServices = useExperienceAnalytics();
  const AsClosureSelector = (state: any) => state.context.asClosure;
  const asClosure = useXstateSelector(
    experienceServices.experienceService,
    AsClosureSelector
  );
  const AsClosureForComparaisonSelector = (state: any) =>
    state.context.asClosureForComparaison;
  const asClosureForComparaison = useXstateSelector(
    experienceServices.experienceService,
    AsClosureForComparaisonSelector
  );

  const options = getOptions(
    t,
    isComparaison ? asClosureForComparaison : asClosure
  );

  return (
    <AutoComplete
      popupIcon={<KeyboardArrowDownIcon />}
      PaperComponent={SelectPaper}
      value={options.find((d: Dic<any>) => d.value === evolutionKey)}
      onChange={(e: React.SyntheticEvent, value: any) =>
        handleChange(value.value)
      }
      disablePortal
      disableClearable
      id="evolution-metric-selector"
      options={options?.filter((o: Dic<any>) => !o.disabled)}
      sx={{ width: 280 }}
      renderInput={(params: any) => (
        <StyledTextField
          {...params}
          label={t("evolution_metric")}
          name={t("Evolution metric")}
          size="small"
        />
      )}
    />
  );
};

export default EvolutionMetricSelector;
